import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {PlayerService} from '../../../../core/services/';
import {PlayerScore} from '../../../../core/models';
import {AppComponent} from '../../../../app.component';

@Component({
  selector: 'app-player-trust-rating',
  templateUrl: './player-trust-rating.component.html',
  styleUrls: ['./player-trust-rating.component.scss']
})
export class PlayerTrustRatingComponent implements OnInit {

  @Input() playerId: string;
  @Input() projectId: string;
  playerScore: PlayerScore;
  loading: boolean = true;
  data: any;
  options: any;

  constructor(
    private playerService: PlayerService,
    public app: AppComponent
  ) {

  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  init() {
    // get the player's score (history) data
    this.playerService.getPlayerScore(this.playerId, this.projectId).subscribe(
      (data) => {
        // current player-score
        this.playerScore = data;
        // trust- and suspicion-score tuples
        let trustScoreData = data.playerScoreHistory.map(h => {
          return {x: Math.round(new Date(h.creationDate).getTime() / 1000), y: h.trustScore};
        });
        trustScoreData.push({x: Math.round(new Date(data.updateDate).getTime() / 1000), y: data.trustScore});

        let suspicionScoreData = data.playerScoreHistory.map(h => {
          return {x: Math.round(new Date(h.creationDate).getTime() / 1000), y: h.suspicionScore};
        });
        suspicionScoreData.push({x: Math.round(new Date(data.updateDate).getTime() / 1000), y: data.suspicionScore});

        // determine x-axis min- and max-value
        let minTimestamp = trustScoreData.length ? trustScoreData[0].x : 0;
        let maxTimestamp = trustScoreData.length ? trustScoreData[trustScoreData.length - 1].x : 0;

        this.data = {
          datasets: [
            {
              showLine: true,
              label: 'Trust Score',
              data: trustScoreData,
              borderColor: '#4caf50',
              fill: false
            },
            {
              showLine: true,
              label: 'Suspicion Score',
              data: suspicionScoreData,
              borderColor: '#ffc107',
              fill: false
            }
          ]
        };

        // see https://www.chartjs.org/docs/latest/
        this.options = {
          tooltips: {
            enabled: false
          },
          elements: {
            point: {
              radius: 0
            }
          },
          legend: {
            display: false
          },
          title: {
            display: false
          },
          scales: {
            yAxes: [{
              display: false,
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 10000
              }
            }],
            xAxes: [{
              display: false,
              ticks: {
                beginAtZero: false,
                min: minTimestamp,
                max: maxTimestamp
              }
            }]
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 20
            }
          }
        };

        this.loading = false;
      }
    );
  }

}
